import { Injectable } from '@angular/core';
import { LOCAL_STORAGE_KEY_MACHINE_FINGERPRINT } from '../const';

const BASE62_CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
const MACHINE_ID_BITS = 20n;
const MACHINE_ID_MASK = (1n << MACHINE_ID_BITS) - 1n;

@Injectable({ providedIn: 'root' })
export class FilterIdService {
  private cachedMachineId: bigint | undefined;

  generateId(): string {
    const id = (BigInt(Date.now()) << MACHINE_ID_BITS) | this.getMachineId();
    return this.toBase62(id);
  }

  private toBase62(value: bigint): string {
    if (value === 0n) return '0';
    let result = '';
    let n = value;
    while (n > 0n) {
      result = BASE62_CHARS[Number(n % 62n)] + result;
      n /= 62n;
    }
    return result;
  }

  private hashToMachineId(input: string): bigint {
    let hash = 2166136261;
    for (let i = 0; i < input.length; i++) {
      hash ^= input.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return BigInt(hash >>> 0) & MACHINE_ID_MASK;
  }

  private getOrCreateMachineSeed(): string {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem(LOCAL_STORAGE_KEY_MACHINE_FINGERPRINT);
      if (stored) return stored;
    }

    const seed = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2);

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LOCAL_STORAGE_KEY_MACHINE_FINGERPRINT, seed);
    }

    return seed;
  }

  private getMachineId(): bigint {
    if (this.cachedMachineId === undefined) {
      this.cachedMachineId = this.hashToMachineId(this.getOrCreateMachineSeed());
    }
    return this.cachedMachineId;
  }
}
